export interface LinkingColumnVisibilityOptions {
  mainStore?: boolean
  accountingStore?: boolean
  shippingStore?: boolean
  erpStore?: boolean
  omsStore?: boolean
  tabsData?: Array<unknown>
}

/** Primary and OMS hubs show linking when they have connected channels in tabsData. */
export const isLinkingHubStore = ({
  mainStore = false,
  omsStore = false,
}: LinkingColumnVisibilityOptions = {}): boolean => {
  return mainStore || omsStore
}

/** Accounting / shipping / ERP source channels never show linking columns. */
export const isStandaloneSourceStore = ({
  accountingStore = false,
  shippingStore = false,
  erpStore = false,
}: LinkingColumnVisibilityOptions = {}): boolean => {
  return accountingStore || shippingStore || erpStore
}

/** Legacy ProductsTable / platform-typewise-list rules for Linking Status + Link Actions. */
export const shouldShowLinkingColumns = (options: LinkingColumnVisibilityOptions = {}): boolean => {
  const {
    mainStore = false,
    accountingStore = false,
    shippingStore = false,
    erpStore = false,
    omsStore = false,
    tabsData = [],
  } = options

  const hasConnectedChannels = Array.isArray(tabsData) && tabsData.length > 0
  if (!hasConnectedChannels) return false

  if (isLinkingHubStore({ mainStore, omsStore })) return true

  return !isStandaloneSourceStore({ accountingStore, shippingStore, erpStore })
}

export const isSourceStoreChannel = ({
  accountingStore = false,
  shippingStore = false,
  erpStore = false,
  omsStore = false,
}: LinkingColumnVisibilityOptions = {}): boolean => {
  return isStandaloneSourceStore({ accountingStore, shippingStore, erpStore }) || omsStore
}

/** Use simplified source-store default columns (no linking) in legacy column builders. */
export const shouldUseSourceStoreDefaultColumns = (
  options: LinkingColumnVisibilityOptions & { hasLinkingColumns?: boolean } = {}
): boolean => {
  const { hasLinkingColumns = false, omsStore = false, ...rest } = options
  if (isStandaloneSourceStore(rest)) return true
  return Boolean(omsStore && !hasLinkingColumns)
}
